export default __webpack_public_path__ + "static/media/logo.bed5f136.gif";